document.addEventListener('DOMContentLoaded', () => {
  const slideshow = document.querySelector('[id^="Slider-"]');
  const slides = slideshow?.querySelectorAll('.slideshow__slide');

  if (!slideshow || !slides || slides.length < 2) return;

  let current = 0;

  // Initial state
  slides.forEach((slide, index) => {
    slide.style.position = 'absolute';
    slide.style.top = 0;
    slide.style.left = 0;
    slide.style.width = '100%';
    slide.style.transition = 'opacity 1s ease-in-out';
    slide.style.opacity = index === 0 ? '1' : '0';
    slide.style.zIndex = index === 0 ? '2' : '1';
  });

  const rotateSlides = () => {
    const prev = current;
    current = (current + 1) % slides.length;

    slides[prev].style.opacity = '0';
    slides[prev].style.zIndex = '1';
    slides[current].style.opacity = '1';
    slides[current].style.zIndex = '2';
  };

  setInterval(rotateSlides, 5000); // Change every 5s
});
